module.exports = __webpack_public_path__ + "static/media/icon-private.23bb7816.svg";